import {
  setAttendeeNetworkHealth,
  setAttendeeCameraStatus,
  showNotification,
  clearNotification,
  showModal,
  setAttendeeReceivedFrame,
  handleAudioInputChanged,
  handleAudioOutputChanged,
  setAttendeeVoiceIntensity,
  updateMeetingStatus
} from '@shoflo/studio-redux/actions';
import { handleRemoteVideoSourcesDidChange } from '@shoflo/studio-redux/middleware';
import {
  setProgram,
  setAttendeeTile,
  updateAttendeePresence,
  setScreenShareActive,
  persistAttendeeId,
  handleVideoInputChanged
} from 'actions/Broadcast';
import { initializeMeetingSession as initializeMeetingSessionFromChimeLib } from '@studio/chime/configuration/initializeMeetingSession';
import { videoTileDidUpdateHandlerForSpeaker } from '@studio/chime/observers/audioVideo/VideoTileDidUpdate/videoTileDidUpdateHandler';
import { createSpeakerContentShareObserver } from '@studio/chime/observers/contentShare/createContentShareObserver';
import { createMeetingEventObserver } from '@studio/chime/observers/eventController/createMeetingEventObserver';
import { onPresenceChangedHandlerForSpeaker } from '@studio/chime/observers/onPresenceChanged/onPresenceChangedHandler';
import { createDeviceChangeObserver } from '@studio/chime/observers/deviceChange/createDeviceChangeObserver';
import { videoTileWasRemovedHandler as defaultVideoTileWasRemovedHandler } from '@studio/chime/observers/audioVideo/VideoTileWasRemoved/videoTileWasRemovedHandler';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';

export default function initializeMeetingSession(
  meetingSession,
  dispatch,
  attendeeResponse,
  meetingResponse,
  videoInputDevice
) {
  const setAttendeeVoiceIntensityData = shouldHaveFeature(
    'studio.audioIndicator'
  )
    ? setAttendeeVoiceIntensity
    : null;

  const videoTileDidUpdateHandler = videoTileDidUpdateHandlerForSpeaker(
    dispatch,
    {
      setAttendeeTile,
      persistAttendeeId,
      setAttendeeCameraStatus,
      setAttendeeVoiceIntensity: setAttendeeVoiceIntensityData
    },
    meetingSession,
    setProgram
  );

  const videoTileWasRemovedHandler = defaultVideoTileWasRemovedHandler(
    meetingResponse,
    attendeeResponse
  );

  const onPresenceChangedHandler = onPresenceChangedHandlerForSpeaker(
    dispatch,
    {
      updateAttendeePresence,
      setAttendeeVoiceIntensity: setAttendeeVoiceIntensityData,
      setAttendeeCameraStatus
    },
    meetingSession
  );

  const contentShareObserver = createSpeakerContentShareObserver(
    dispatch,
    setScreenShareActive,
    meetingResponse,
    attendeeResponse
  );

  // Add the event observer to forward meeting metrics to datadog
  const meetingEventObserver = createMeetingEventObserver(
    dispatch,
    {
      showModal,
      showNotification,
      clearNotification,
      updateMeetingStatus,
      setDesiredAttendeeCameraStatus: setAttendeeCameraStatus
    },
    meetingSession,
    attendeeResponse.Attendee.AttendeeId,
    videoInputDevice
  );

  const deviceChangeObserver = createDeviceChangeObserver(
    dispatch,
    {
      handleAudioInputChanged,
      handleAudioOutputChanged,
      handleVideoInputChanged
    },
    attendeeResponse
  );

  initializeMeetingSessionFromChimeLib(
    dispatch,
    {
      setAttendeeNetworkHealth,
      setAttendeeReceivedFrame
    },
    {
      onPresenceChangedHandler,
      videoTileDidUpdateHandler,
      videoTileWasRemovedHandler,
      remoteVideoSourcesDidChangeHandler: handleRemoteVideoSourcesDidChange
    },
    { contentShareObserver, meetingEventObserver, deviceChangeObserver },
    meetingSession,
    meetingResponse,
    attendeeResponse,
    true
  );
}
